
import Vue from 'vue';
export default Vue.extend({
  props: {
    src: {
      type: String,
      required: true,
    },
    cookieConsentServiceName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      consentForIframeGiven: process.env.STORYBOOK_ENABLED ? true : false,
      storybookEnabled: process.env.STORYBOOK_ENABLED,
    };
  },
  methods: {
    loadOrBlockIframe(e: boolean) {
      if (this.noCookieNeeded) {
        this.consentForIframeGiven = true;
      } else {
        this.consentForIframeGiven = e;
      }
    },
  },
  computed: {
    noCookieNeeded(): boolean {
      return this.cookieConsentServiceName ? false : true;
    },
  },
});
